<template>
<div>
  <div class="row">
    <div class="col-md-12">
      <span>
        Defina aqui os usuários que poderão editar este projeto.
      </span>
    </div>
  </div>
  <div class="row" v-if="showMsg || showMsgSuccess">
    <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
      {{msg}}
      <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div v-if="showMsgSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
      {{msgSuccess}}
      <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>E-mail</label>
        <input type="text" class="form-control" v-model="email"/>
      </div>
    </div>
    <div class="col-md-12">
      <button class="btn" v-on:click.stop.prevent="addUser()">Adicionar</button>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <h3>Lista de Usuários</h3>
      <div class="activity" v-if="users && users.length > 0" v-for="a in users" v-bind:key="a.UserId">
        <h5>{{a.name}}</h5>
        <div v-html="a.email"></div>
        <button class="btn" v-on:click.stop.prevent="removeUser(a.UserId)">Remover</button>
      </div>
      <h4 class="projects-empty" v-if="!users || users.length == 0">Projeto não possui usuários editores.</h4>
    </div>
  </div>

</div>
</template>

<script>
import auth from '../../services/auth'
import Functions from '../../utils/functions'
import { API } from '../../services/api'

export default {
  name: 'ProjectUsers',
  props: ['project'],
  components: {

  },
  data(){
    return {
      msg: '',
      showMsg: false,
      users: null,
      msg: '',
      showMsg: false,
      msgSuccess: '',
      showMsgSuccess: false,
      email: null,
      page: 'users',
    }
  },
  mounted(){
    this.projectId = this.project.ProjectId;
    if(this.project.AllowedUsers){
      this.users = this.project.AllowedUsers
    }
  },
  methods: {
    addUser(){
      this.$emit('showloading');
      if(this.validate()){
        this.$http.post(API.Projects.updateProject + this.projectId, {email: this.email, page: this.page, action: 'insert'}, 
        {headers: auth.getHeaders()}).then((res) => {
            if(res.body.success === true){
              this.msgSuccess = res.body.message;
              this.showMsgSuccess = true;
              this.email = null;
              if(!this.users){
                this.users = [];
              }
              this.users.push(res.body.user);
            }else{
              this.msg = res.body.message;
              this.showMsg = true;
            }
            this.$emit('hideloading');
          }, (error) => {
            this.msg = 'Erro ao adicionar usuário.';
            this.showMsg = true;
            this.$emit('hideloading');
          });
      }else{
        this.$emit('hideloading');
      }
    },
    removeUser(UserId){
      var r = confirm("Deseja remover este usuário?");
      if(r == true){
        this.$emit('showloading');
        this.$http.post(API.Projects.updateProject + this.projectId, {UserId: UserId, page: this.page, action: 'delete'}, 
        {headers: auth.getHeaders()}).then((res) => {
            if(res.body.success === true){
              this.successMsg = res.body.message;
              this.showSuccessMsg = true;
              this.users = this.users.filter((a) => {
                return a.UserId !== UserId
              })
            }else{
              this.msg = res.body.message;
              this.showMsg = true;
            }
            this.$emit('hideloading');
          }, (err) => {
            this.$emit('hideloading');
            this.msg = err.body.message;
            this.showMsg = true;
          });
      }
    },
    validate(){
      if(!this.email || this.email == ''){
        this.msg = 'Deve inserir o email para adicionar.';
        this.showMsg = true;
        return false;
      }
      return true;
    },
    hideMsg(){
      this.msg = "";
      this.msgSuccess = "";
      this.showMsg = false;
      this.showMsgSuccess = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.alert-success, .alert-danger{
  width: 100%;
}
h4{
  color: #00AE39;
  margin-bottom: 1px;
}
span{
  font-size: 15px;
}
.projects-empty{
  width: 100%;
  padding: 20px;
  text-align: center;
  margin-top: 20px;
}
.form-config{
    margin-top: 20px;
    .row{
      padding: 20px;
      border-bottom: thin solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }
    .btn{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &.clear-project{
        background-color: red;
      }
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
}
.activity{
  padding: 10px;
  background-color: #eee;
  margin-top: 20px;
  border-radius: 5px;
  font-size: 14px;
  display: block;
  position: relative;
  h5{
    font-family: RalewayBold;
    padding-bottom: 10px;
  }
  .btn{
    font-size: 14px;
    background-color: red;
    position: absolute;
    right: 10px;
    top: 10px;
  }
  span{
    font-size: 12px;
    color: #999;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/manage-project/Users.vue